import { FormSection } from "components/FormControls/FormSection";
import { useMessage } from "hooks/intl";
import { CampaignTriggers, CampaignTriggersUnion } from "types/campaigns";
import { EventCampaignSimulation } from "../CampaignTrigger/EventCampaignSimulation";
import { InternalEventCampaignSimulation } from "../CampaignTrigger/InternalEventCampaignSimulation";

interface Props {
  trigger: CampaignTriggersUnion;
  customEvent?: {
    type?: string;
    body?: any;
  };
}

export const EventDetails = ({ trigger, customEvent }: Props) => {
  const { message } = useMessage();

  return (
    <FormSection title={message({ id: "eventDetails" })}>
      <>
        {trigger === CampaignTriggers.CUSTOM_EVENT && (
          <EventCampaignSimulation customEvent={customEvent} />
        )}
        {trigger === CampaignTriggers.INTERNAL_EVENT && (
          <InternalEventCampaignSimulation />
        )}
      </>
    </FormSection>
  );
};
